import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { authService } from '../api/authService';
import { Button, TextField, Container, Typography, Box, Alert } from '@mui/material';

const CambioPasswd: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const username = location.state?.username;

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  if (!username) {
    return (
        <Container maxWidth="sm">
            <Box mt={5}>
                <Alert severity="error">Errore: Username mancante. Torna al login.</Alert>
                <Button variant="contained" color="primary" onClick={() => navigate('/login')} style={{ marginTop: '10px' }}>
                    Vai al Login
                </Button>
            </Box>
        </Container>
    );
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    if (newPassword.length < 6) {
      setError('La password deve essere di almeno 6 caratteri.');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('Le password non corrispondono.');
      return;
    }

    try {
      await authService.changePassword(username, newPassword);
      setSuccess(true);
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (err: any) {
      setError(err.response?.data || 'Errore durante il cambio password.');
    }
  };

  if (success) {
    return (
      <Container maxWidth="sm">
        <Box mt={5}>
          <Alert severity="success">Password aggiornata con successo! Reindirizzamento al login...</Alert>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="sm">
      <Box mt={5} display="flex" flexDirection="column" alignItems="center">
        <Typography variant="h4" gutterBottom>
          Cambio Password Obbligatorio
        </Typography>
        <Typography variant="body1" gutterBottom>
          È necessario impostare una nuova password per l'utente <strong>{username}</strong>.
        </Typography>
        <form onSubmit={handleSubmit} style={{ width: '100%', marginTop: '20px' }}>
          <TextField
            label="Nuova Password"
            type="password"
            fullWidth
            margin="normal"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            helperText="Minimo 6 caratteri"
          />
          <TextField
            label="Conferma Nuova Password"
            type="password"
            fullWidth
            margin="normal"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
          {error && (
            <Alert severity="error" style={{ marginTop: '10px' }}>
              {error}
            </Alert>
          )}
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            style={{ marginTop: '20px' }}
          >
            Salva nuova password
          </Button>
        </form>
      </Box>
    </Container>
  );
};

export default CambioPasswd;
